import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SV_URL } from '../../@core/utils/utils';

export interface TarefaPendente {
  id: number;
  titulo: string;
  descricao: string;
  data: string;
  prioridade: string;
  status: string;
}

/**
 * Provider HTTP para operações de tarefas.
 */
@Injectable({ providedIn: 'root' })
export class TarefasProvider {

  public id: string;

  constructor(public http: HttpClient) {}

  /**
   * Lista tarefas pendentes do usuário.
   *
   * @param user - Login do usuário
   * @returns Observable com array de tarefas pendentes
   */
  getTarefasPendentes(user: string): Observable<TarefaPendente[]> {
    return this.http.get<TarefaPendente[]>(`${SV_URL}/getTarefasPendentes/${user}`);
  }

  saveTarefa(user, solicitante, data, prioridade, descricao, titulo) {
    const url: string = SV_URL + '/postTarefa';
    const postParams = { user, solicitante, data, prioridade, descricao, titulo };
    this.http.post(url, postParams).subscribe();
  }

  leitura(id) {
    const url: string = SV_URL + '/postLeitura';
    this.http.post(url, { id }).subscribe();
  }

  conclusao(id) {
    const url: string = SV_URL + '/postConclusao';
    this.http.post(url, { id }).subscribe();
  }
}
